import * as React from "react";

export default function PackageStatusContainer(props: {
  children: React.ReactNode;
}) {
  return (
    <>
      <div style={{ minHeight: 120 }} />
      <div
        style={{
          textAlign: "right",
          position: "absolute",
          bottom: 0,
          right: 0,
          padding: "1em 1.5em",
        }}
      >
        {props.children}
      </div>
    </>
  );
}
